import React, { useContext } from 'react'
import { Knob } from './Knob';
import { KnobContext, KnobContextMediator } from './KnobContext';

export function TemplateWithVariables<T extends Knob.Map>(variablesDescriptorMap:T, render: React.FunctionComponent<Knob.Value<T>>) {
    return React.memo<{variables?: Knob.Value<T>}>(({variables: _variables}) => {
        const variables = _variables || (useContext(KnobContext) as KnobContextMediator<T>).setup(variablesDescriptorMap)
        return render(variables)
    })
}